export default __webpack_public_path__ + "static/media/digi2.732581e7.webp";